import { render, staticRenderFns } from "./impacted-person-supports-form.vue?vue&type=template&id=02c8fee8&scoped=true"
import script from "./impacted-person-supports-form.vue?vue&type=script&lang=js"
export * from "./impacted-person-supports-form.vue?vue&type=script&lang=js"
import style0 from "./impacted-person-supports-form.vue?vue&type=style&index=0&id=02c8fee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c8fee8",
  null
  
)

export default component.exports